// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2wWCI","row":"Node_row__31dsR","label":"Node_label__1plSg","footer":"Node_footer__2yurY"};